import { Flex } from "@scaleaq/sui-react";
import styles from "./LoadingGhost.root.module.scss";
import clsx from "clsx";

export namespace LoadingGhostRoot {
    export type ElementName = "LoadingGhost.Root";
    export type ElementType = HTMLElement;
    export type Props = Flex.Root.Props;
}

export const LoadingGhostRoot = (props: LoadingGhostRoot.Props) => {
    const { className, ...restProps } = props;

    return(
        <Flex.Root className={clsx(styles["loading-ghost-root"], className)} {...restProps} />
    );
}